import * as React from "react";

import "./promo-codes.scss";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {TimeoutAction}  from "@Common/react/timeout-action";
import {UseState}       from "@Common/react/use-state";
import {cascadeFind}    from "@Common/utils/cascade";

import {AddedCodes}      from "./added-codes/added-codes";
import {AddingForm}      from "./adding-form/adding-form";
import {NewCodeMessages} from "./new-code-messages/new-code-messages";

export const PromoCodesSection = ({store, next}) => cs(
    consumeContext("company"),
    ({company}) => next({
        available: cascadeFind(store.cart.items, "[*].billingAvailable.promoCode") && isApiTrue(company?.prefs?.allowPromoCodes),
        render: () => cs(
            ["apiErrors", (_, next) => UseState({next})],
            ["newCodeMessages", (_, next) => NewCodeMessages({next})],
            ({apiErrors, newCodeMessages}) => (
                <div className="promo-codes-1ce">
                    {AddingForm({
                        store,
                        onError: apiErrors.onChange,
                        onAdded: newCodeMessages.setCodes,
                        onChange: () => {
                            apiErrors.onChange(null);
                            newCodeMessages.clear();
                        },
                    })}

                    {newCodeMessages.render()}

                    {apiErrors.value?.map((error) => cs(
                        keyed(error),
                        () => TimeoutAction({
                            delay: 50000,
                            action: () => apiErrors.change((_) => _.filter((e) => e !== error)),
                        })
                    ))}

                    {!!apiErrors.value?.length && (
                        <div className="errors">
                            {apiErrors.value?.map((error, i) => (
                                <div className="error" key={i} xd-qa-type="label" xd-qa-name="Promo Error">
                                    {error}
                                </div>
                            ))}
                        </div>
                    )}

                    {AddedCodes({store})}
                </div>
            )
        )
    }),
);
